<template>
  <el-dialog custom-class="mini-dialog" title="修改成本价" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-form :model="form" ref="form1" :rules="rules">

      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="采购单价" :label-width="formLabelWidth" prop="costprice">
            <el-input-number v-model="form.costprice" :controls="false" style="width: 150px"  :min="0" @change="changNum"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="false">
        <el-col :span="10">
          <el-form-item label="核算单价" :label-width="formLabelWidth" prop="price">
            <el-input-number v-model="form.price" :controls="false" style="width: 150px"  :min="0"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="折扣" :label-width="formLabelWidth">
            {{(form.price*10.00/form.costprice)|numeric(2)}}
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="isDisable">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {updatecostprice} from '@/api/set/csagreement';
  export default {
    name: "UpdateExpressFee",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        form: {  //表单数据
          costprice:0,
          price:0,
          discount:0
        },
        tabledata:[],
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          costprice: [
            {required: true, message: '请输入采购单价', trigger: 'blur'},
          ],
          price: [
            {required: true, message: '请输入核算单价', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      show(item) {
        this.initForm();
        this.tabledata=item
        this.form.costprice=item.costtotalmoney/item.totalnumber;
        this.form.price=item.totalmoney/item.totalnumber;
        this.form.discount=(this.form.price/this.form.costprice);
        this.dialogFormVisible = true;
      },
      changNum() {
        if (this.tabledata.isgift == 1) {//固定价格的

        } else
          this.form.price = this.$numeric(this.form.costprice * this.form.discount, 3);
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.isDisable=true;
            updatecostprice({
              erpserial: this.tabledata.erpserial,
              costprice:this.form.costprice,
              price: this.form.price,
              seedcode:this.tabledata.seedcode,
              packagesize:this.tabledata.packagesize
            }).then(response => {
              if(response.data.code==0){
                this.$message({
                  message: "修改成功",
                  type: 'success'
                })
                this.dialogFormVisible = false
                //刷新列表
                this.$emit("afertupdate",this.tabledata,this.form.costprice,this.form.price)
              }else {
                this.isDisable=false;
                this.$message({
                  message: "修改失败",
                  type: 'error'
                })
              }
            });
          }
        });
      },
      initForm() {
        this.isDisable=false;
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
      }
    },
    mounted() {
    },
    components: {
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/UpdateCostPrice.vue